import { Faq16, Header2, Header3, Tooltip } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './PublicationPrice.css';

interface IPublicationPriceProps {
  discountPrice: string | null;
  price: string;
  days: string;
  hintHeader?: string;
  hintTitle?: string;
}

export const PublicationPrice = ({ discountPrice, price, days, hintHeader, hintTitle }: IPublicationPriceProps) => {
  return (
    <div className={styles['wrapper']}>
      {discountPrice && (
        <div className={styles['discount_price']}>
          <Header2 color="gray60_100">{discountPrice}</Header2>
        </div>
      )}

      <Header2>{price}</Header2>
      <Header3 fontWeight="normal">/{days}</Header3>

      {hintTitle && (
        <div className={styles['hint']}>
          <Tooltip header={hintHeader} title={hintTitle} theme="black">
            <Faq16 color="primary_100" cursor="pointer" />
          </Tooltip>
        </div>
      )}
    </div>
  );
};
